import { render, staticRenderFns } from "./ConfigureRelationships.vue?vue&type=template&id=7bc3c4d2&scoped=true"
import script from "./ConfigureRelationships.vue?vue&type=script&lang=js"
export * from "./ConfigureRelationships.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRelationships.vue?vue&type=style&index=0&id=7bc3c4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3c4d2",
  null
  
)

export default component.exports